import { initializeApp } from "firebase/app";
import { getMessaging, onMessage, isSupported } from "firebase/messaging";
import { toast } from "react-toastify";

export const firebaseConfig = {
	apiKey: "AIzaSyBVJ7LnmPdaoRJsxGi0PfTS5TCGvaZ5eXM",
	authDomain: "viteslink-80e0c.firebaseapp.com",
	projectId: "viteslink-80e0c",
	storageBucket: "viteslink-80e0c.firebasestorage.app",
	messagingSenderId: "360986729349",
	appId: "1:360986729349:web:bae5f1720cc2b30940c2ec",
	measurementId: "G-NEZ7KEPBTY"
};

const app = initializeApp(firebaseConfig);
export let messaging: ReturnType<typeof getMessaging> | null = null;

(async () => {
	const supported = await isSupported();

	if (!supported) {
		return;
	}

	messaging = getMessaging(app);

	onMessage(messaging, payload => {
		console.log("[FG] Message received:", payload);

		const { title, body } = payload.notification || {};
		const url = payload.data?.url;

		toast(
			<div style={{ cursor: url ? "pointer" : "default" }}>
				{title && <strong>{title}</strong>}
				{body && <div style={{ marginTop: 4 }}>{body}</div>}
			</div>,
			{
				position: "top-right",
				autoClose: false,
				closeOnClick: true,
				onClick: () => {
					if (url) {
						window.open(url, "_blank");
					}
				}
			}
		);
	});
})();
// export const messaging = getMessaging(app);
//
// onMessage(messaging, payload => {
// 	console.log("[FG] Message received:", payload);
//
// 	const { title, body } = payload.notification || {};
// 	const url = payload.data?.url;
// 	toast(
// 		<div style={{ cursor: url ? "pointer" : "default" }}>
// 			<strong>{title}</strong>
// 			{body && <div style={{ marginTop: 4 }}>{body}</div>}
// 		</div>,
// 		{
// 			position: "top-right",
// 			autoClose: false,
// 			closeOnClick: true,
// 			onClick: () => {
// 				if (url) {
// 					window.open(url, "_blank");
// 				}
// 			}
// 		}
// 	);
// });
